"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationGarden = function IllustrationGarden() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M6 52h54"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "35.511",
    height: "4.533",
    x: "7",
    y: "42.933",
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "0.756"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.023 42.933h29.466v-9.067a2.267 2.267 0 00-2.267-2.266H12.29a2.267 2.267 0 00-2.266 2.266v9.067z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#77558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M39.49 35.378H10.021M10.023 52v-4.533M39.489 52v-4.533"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5",
    d: "M58.378 34.244c0 6.886-3.214 8.69-7.178 8.69s-7.178-1.804-7.178-8.69C44.023 27.36 47.236 18 51.2 18s7.178 9.36 7.178 16.244z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#77558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M51.578 52V33.867M51.578 40.667l-2.267-3.023M51.578 37.645l2.267-2.267M39.49 39.156H10.021"
  }));
};

var _default = IllustrationGarden;
exports.default = _default;